import { Box, Heading } from "@chakra-ui/react";
import ScriptDisplay from "./ScriptDisplay";
interface SearchLayoutProps {
  searchText: string;
  scripts: any[];
}

const SearchLayout = (props: SearchLayoutProps) => {
  const { searchText = "", scripts } = props;
  return (
    <Box
      padding={{
        base: "16px",
        lg: "36px 40px",
      }}
    >
      <Heading size="lg" mb={4}>
        {`Scripts found for "${searchText}"`}
      </Heading>
      {scripts.map((script) => (
        <ScriptDisplay key={script.id} script={script} />
      ))}
    </Box>
  );
};

export default SearchLayout;
